import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
import { SplitText } from "../gsap/SplitText"
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

export default {
  init() {

    gsap.config({ nullTargetWarn: false });

    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top - 85}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    $('.menu-icon').on('click', function(event) {
      $('.top-bar').toggleClass('open');
      $(this).toggleClass('open');
      setTimeout(function() {
        $('.title-bar').toggleClass('mob-open');
      }, 200);
      event.preventDefault();
    });

    let hpScroll = gsap.timeline({
      scrollTrigger: {
        trigger: '.mqb',
        start: 'bottom 70%',
        scrub: true,
      },
    })
    hpScroll.to('header', {backgroundColor: '#003057', duration: 1, ease: 'power4.out'})
    .to('.top-bar .menu li a', {fontSize: '16px', duration: 1, ease: 'power4.out'}, '-=1')
    .to('.top-bar .home .brand img', {width: '190px', duration: 1, ease: 'power4.out'}, '-=1')


    $('.carousel').slick({
      arrows: false,
      dots: true,
    });

    $('.video-slider').slick({
      arrows: true,
      dots: false,
      prevArrow:"<button type='button' class='slick-prev' aria-label='go to previous video'><svg width='32' height='47' viewBox='0 0 32 47' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M28.044 7.30304e-06C28.8486 -0.000644944 29.6343 0.229236 30.296 0.658939C30.9577 1.08864 31.464 1.6977 31.7471 2.40472C32.0303 3.11173 32.0769 3.88304 31.8806 4.61557C31.6844 5.3481 31.2547 6.00696 30.6489 6.50412L9.95428 23.5003L30.6471 40.4965C31.436 41.1446 31.9184 42.0604 31.9881 43.0424C32.0578 44.0244 31.7092 44.9922 31.0188 45.7328C30.3284 46.4735 29.3529 46.9263 28.3068 46.9918C27.2608 47.0572 26.2299 46.7299 25.4409 46.0818L1.34891 26.2921C0.925184 25.9438 0.585629 25.5145 0.352989 25.0331C0.12035 24.5516 -1.68655e-06 24.029 -1.63757e-06 23.5003C-1.58859e-06 22.9716 0.12035 22.449 0.35299 21.9675C0.585629 21.4861 0.925185 21.0568 1.34891 20.7085L25.4409 0.918819C26.1604 0.325092 27.086 -0.00162928 28.044 7.30304e-06Z' fill='#0061A0'/></svg></button>",
      nextArrow:"<button type='button' class='slick-next' aria-label='go to next video'><svg width='32' height='47' viewBox='0 0 32 47' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.95601 47C3.1514 47.0006 2.36575 46.7708 1.70402 46.3411C1.0423 45.9114 0.536031 45.3023 0.252864 44.5953C-0.0303029 43.8883 -0.0768772 43.117 0.119362 42.3844C0.315601 41.6519 0.745307 40.993 1.35106 40.4959L22.0457 23.4997L1.35295 6.50351C0.563981 5.85541 0.0815772 4.93962 0.0118639 3.95762C-0.0578494 2.97562 0.290837 2.00784 0.981213 1.26718C1.67159 0.526529 2.6471 0.0736651 3.69315 0.0082204C4.73921 -0.0572243 5.77011 0.27011 6.55908 0.918213L30.6511 20.7079C31.0748 21.0562 31.4144 21.4855 31.647 21.9669C31.8797 22.4484 32 22.971 32 23.4997C32 24.0284 31.8797 24.551 31.647 25.0325C31.4144 25.5139 31.0748 25.9432 30.6511 26.2915L6.55907 46.0812C5.83958 46.6749 4.91396 47.0016 3.95601 47V47Z' fill='#0061A0'/></svg></button>",
      responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
        },
      },
      ],
    });

    $('.tabs-title .txt-link').on('click', function() {
      window.location.href = $(this).attr('href');
    });   


    // Marquee Banner

    gsap.to('.marquee-banner h1', {y: 0, opacity: 1, duration: 1, ease: 'power4.out'})
    gsap.to('.marquee-banner p', {y: 0, opacity: 1, duration: 1, delay: 0.3, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1')

     // Cols Split

     const colsHeadline = document.querySelector('.callout-cols h2');
     const colsSubHealdine = document.querySelector('.callout-cols p');

     let cols = gsap.timeline({
      scrollTrigger: {
        trigger: '.callout-cols',
        start: 'top 60%',
      },
    })
     cols.to(colsHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(colsSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=0.8')


     // Sixty Fourty Split

     const sfsplit = gsap.utils.toArray('.six-four-split')
     sfsplit.forEach((sp, i) => {
      let splitWrp = gsap.timeline({
        scrollTrigger: {
          trigger: sp,
          start: 'top 60%',
        },
      })
      splitWrp.to(sp.querySelector('.eyebrow'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'})
      .to(sp.querySelector('h2'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(sp.querySelector('.ptxt'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(sp.querySelector('img'), {x: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(sp.querySelectorAll('.six-four-split .sf-btn'), {y: 0, opacity: 1, ease: 'power4.out', stagger: 0.01}, '-=0.8')
      
    })

     // Fifty Fifty

     const fiftysplit = gsap.utils.toArray('.fifty-split')
     fiftysplit.forEach((fif, i) => {
      let fiftFifty = gsap.timeline({
        scrollTrigger: {
          trigger: fif,
          start: 'top 60%',
        },
      })
      fiftFifty.to(fif.querySelector('.eyebrow'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'})
      .to(fif.querySelector('.sh'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(fif.querySelector('h2'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(fif.querySelector('.cotxt'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(fif.querySelector('img'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=0.8')
      .to(fif.querySelectorAll('a'), {y: 0, opacity: 1, duration: 0.5, ease: 'power4.out', stagger: {amount: 0.01}}, '-=0.8')
    })

     // Fifty Fifty Boxes

     const fiftybxs = gsap.utils.toArray('.fifty-split-boxes')
     fiftybxs.forEach((fb, i) => {
      let ffb = gsap.timeline({
        scrollTrigger: {
          trigger: fb,
          start: 'top 80%',
        },
      })
      ffb.to(fb.querySelectorAll('.bcw'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)', stagger: {amount: 0.07}})
    })

     // Video Carousel

     const vcar = gsap.utils.toArray('.video-carousel')
     vcar.forEach((vc, i) => {
      let vcar = gsap.timeline({
        scrollTrigger: {
          trigger: vc,
          start: 'top 80%',
        },
      })
      vcar.to(vc.querySelectorAll('h2'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)'})
      .to(vc.querySelectorAll('a'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)'}, '-=0.7')
      .to(vc.querySelectorAll('h3'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)'}, '-=0.8')
      .to(vc.querySelectorAll('p'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)'}, '-=0.9')
      .to(vc.querySelectorAll('.slick-next'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)'}, '-=1')
      .to(vc.querySelectorAll('.slick-prev'), {y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.4)'}, '-=1.1')
    })


     $('.button-sec, .button-sec a').on('click', function(event) {
      $('#calFrame').foundation('open');
      event.preventDefault();
    });

     $('.button-sec-main, .button-sec-main a').on('click', function(event) {
      $('#calFrameMain').foundation('open');
      event.preventDefault();
    });

     $('.button-sec-az, .button-sec-az a').on('click', function(event) {
      $('#calFrameAZ').foundation('open');
      event.preventDefault();
    });

     $('.button-sec-sf, .button-sec-sf a').on('click', function(event) {
      $('#calFrameSF').foundation('open');
      event.preventDefault();
    });

     $('.close-button').on('click', function() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100)
    });


     $('.kill-link').on('click', function(event) {
      event.preventDefault();
    });

     // Stop Youtube videos from playing when modal is closed

     $('[data-reveal]').on('closed.zf.reveal', function () {
      let videoIframeSrc = $(this).find('iframe').attr('src');
      $(this).find($('.responsive-embed')).children('iframe').attr('src', '');
      setTimeout(() => {
        $(this).find($('.responsive-embed')).children('iframe').attr('src', videoIframeSrc);
      }, 100)
    });

   },
   finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js